import script from "/app/pages/Home.vue?type=script";
import "/app/pages/Home.vue?type=style";
import { render } from "/app/pages/Home.vue?type=template";
script.render = render;
export default script;
